module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_6005.514c86c9.png";